window.onerror = function (msg, url, lineNo, columnNo, error) {
	alert(msg + '\n' +lineNo+':'+columnNo+ '\n' + error.stack)
}
window.onunhandledrejection = (e) =>{
	alert(e.reason.message + '\n'+e.reason.stack)
}
import  'bootstrap/scss/bootstrap.scss'
import  'bootstrap-icons/font/bootstrap-icons.scss'
import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
	}
});

export default app;
